import { Typography } from '@mui/material'
import { Suspense } from 'react'
import { lazyWithRetry } from 'utils/lazyWithRetry'
import { useTranslation } from 'react-i18next'
import { FieldProps } from 'react-jsonschema-form'

const RALSelector = lazyWithRetry(
  () => import('components/RALSelector/RALColorSelector'),
)

export const RalSelectorField = (props: FieldProps<string>) => {
  const { t } = useTranslation()
  return (
    <Suspense
      fallback={
        <Typography
          variant="caption"
          style={{ alignSelf: 'center', marginTop: '1em' }}
        >{`${t('common:loading')}...`}</Typography>
      }
    >
      <RALSelector
        selectedRALId={props.formData}
        onRALIdSelected={(ralId) => {
          props.onChange(ralId)
        }}
        size="small"
        label={t(`${props.uiSchema['ui:label-translation-key']}`, {
          ns: 'project',
        })}
        inputProps={{
          style: {
            padding: '2px 0 2px 0',
            fontSize: '12px',
          },
        }}
      />
    </Suspense>
  )
}
